<template>
    <div style="background:#F9F9FB">
        <Mainlayout></Mainlayout>
    
        <!-- <br /> <br /> -->
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
                <div class="text-left">
                    <br /><br /><br /><br />
    
                    <div class="m-3">
                        <CCard class="bg-white p-3" style="border:none; border-radius: 20px;">
                            <img src="../assets/img/arrow-left.png" style="max-width:20px" />
                            <label class="ml-5" style="position: absolute;">Back to home</label>
    
                            <CRow class="p-3">
                                <div>
                                    <img v-if="tour.FilePath != null" :src="getBanner(tour.FilePath)" style="max-width: 250px;" />
                                    <img v-else src="../assets/img/ss.png" style="max-width:250px" />
    
                                </div>
                                <div class="ml-3">
                                    <h1 class="custom-24px-600 text-black mb-4"> {{ tour.Title }} </h1>
                                    <h1 class="custom-16px-500 mb-3"> EVENT </h1>
                                    <div class=" mb-3">
                                        <img src="../assets/img/briefcase2.png" style="max-width:20px" />
                                        <label class="ml-3" style="position: absolute;"> Anjuran : {{ tour.Organizer }} </label>
                                    </div>
                                    <div class=" mb-3">
                                        <img src="../assets/img/loc.png" style="max-width:20px" />
                                        <label class="ml-3" style="position: absolute;"> {{ tour.Location }}</label>
                                    </div>
                                    <div class=" mb-3">
                                        <img src="../assets/img/clock.png" style="max-width:20px" />
                                        <label class="ml-3" style="position: absolute;"> {{ tour.Time }} </label>
                                    </div>
                                    <br /><br /><br />
                                    <h1 class="custom-32px-600 text-black" style="padding-top: 19px;"> RM {{ tour.Amount}}</h1>
                                </div>
                                <div class="d-md-none">
                                    <br /><br /><br />
                                </div>
                                <CCard class="button-blue custom-rule text-white" @click="downloadRule(tour.FilePathTerms)">
                                    <CRow style="align-items: center; justify-content: center; padding-top: 8px;">
                                        <img src="../assets/img/ppt.png" style="max-width:25px; height: 25px;" />
                                        <label class="ml-2 mb-0" style="font-size: 18px;">Rules and Regulation</label>
                                        <img src="../assets/img/download-circle.png" class="ml-2" style="max-width:25px; height: 25px;" />
                                    </CRow>
    
                                </CCard>
    
    
                            </CRow>
    
                            <hr />
    
                            <h1 class="custom-32px-600 mt-2" style="font-weight: 500;"> Join Now </h1>
                            <br />
                            <div>
                                <label> Team's Name </label>
                                <input type="text" class="border-white-50px" placeholder="Name" v-model="TeamName" @input="validateTeamName"/>
                                <small v-if="teamNameError" class="text-danger">{{ teamNameError }}</small>
                            </div>
                            <br />
                            <div>
                                <label> Manager's Name </label>
                                <input type="text" class="border-white-50px" placeholder="Your Name" v-model="ManagerName"  @input="validateManagerName"/>

                                <small v-if="managerNameError" class="text-danger">{{ managerNameError }}</small>
                            </div>
                            <br />
                            <div>
                                <label> Tournament's Name </label>
                                <input type="text" class="border-grey-50px" placeholder="Your Name" v-model="tour.Title" disabled/>
                            </div>
                            <br />
                            <div>
                                <label> Category </label>
                                <input type="text" class="border-white-50px" placeholder="Category" v-model="tour.Category" />
                            </div>
                            <br />
                            <div>
                                <label> Amount </label>
                                <input type="text" class="border-grey-50px" placeholder="Amount" v-model="totalAmount" disabled/>
                            </div>
                            <br />
                            <CRow>
    
                                <CCol sm="3"> <label> Emails </label>
                                    <input type="text" class="border-white-50px" placeholder="Your Email Address" v-model="Email" @input="validateEmail" />
                                    <small v-if="emailError" class="text-danger">{{ emailError }}</small></CCol>
                                <CCol sm="3">
                                    <label>Identity Number </label>
                                    <input type="text" class="border-white-50px" placeholder="Your Identity (IC Number)" v-model="IdentityNumber" @input="validateIdentityNumber"/>
                                    <small v-if="identityNumberError" class="text-danger">{{ identityNumberError }}</small>
                                </CCol>
                                <CCol sm="3">
                                        <div>
                                            <label> Phone Number </label>
                                            <div class="border-white-50px">
                                                <div class="card-grey-50px">
                                                    <img src="../assets/img/my.jpg" style="width: 22px; top: 4px; position: absolute;" />
                                                    <input type="NUMBER" class="input-no-border" style="color: #A3A3A3;" placeholder="0123344567" v-model="PhoneNumber" @input="validatePhoneNumber"/>
                                                    
                                                </div>
                                              
                                            </div>
                                            <small v-if="phoneError" class="text-danger">{{ phoneError }}</small>
                                        </div>
                                    </CCol>
                                <CCol sm="3">
                                    <label> Tahap Level  <img @click="OpenPopup()" class="ml-2" src="../assets/img/iconInfo.png" style="max-width:20px" 
                                                     /></label>
                                    <v-select v-model="SelectedLevel" :options="level" label="Name" placeholder="--Sila Pilih Tahap--" required></v-select>
    
                                </CCol>
    
                            </CRow>
                            <CRow class="mt-3">
                                <CCol sm="6">
                                    <div>
                                        <label> Additional fees per member(RM)</label>
                                        <input type="number" class="border-grey-50px" placeholder="1" v-model="tour.ChargePerMember" disabled/>
                                    </div>
                                </CCol>
                            </CRow>
                            <br />
                            <CCard class="card-custom-grey p-2">
                                <div class=" mb-3">
                                    <span @click="AddMember"> 
                                            <img src="../assets/img/Plus2.png" style="max-width:20px" />
                                            <label class="ml-2" style="position: absolute; color: #064BB4; font-size: 14px; font-weight: 600; position: absolute;"> Add Member </label>
                                          </span>
                                </div>
                                <CRow v-for="(item, index) in members" v-bind:key="item.Id" class="mb-2">
                                    <CCol sm="12" md="6" lg="3">
                                        <div class="mb-2">
                                            <label> Name </label>
                                            <input type="text" class="border-white-50px" placeholder="Member Name" v-model="item.Name" />
                                        </div>
                                    </CCol>
                                    <CCol sm="12" md="6" lg="3">
                                        <div class="mb-2">
                                            <label> Identity Number</label>
                                            <input type="text" class="border-white-50px" v-model="item.IdentityNumber" placeholder="Your Identity (IC Number)"  @input="validateIdentityNumberArray(item)" />
                                            <span v-if="item.identityNumberError" class="text-danger">{{ item.identityNumberError }}</span>
                                        </div>
                                    </CCol>
                                    <CCol sm="12" md="6" lg="3">
                                        <div>
                                            
                                            <label> Phone Number </label>
                                            <div class="border-white-50px">
                                                <div class="card-grey-50px">
                                                    <img src="../assets/img/my.jpg" style="width: 22px; top: 4px; position: absolute;" />
                                                    <input type="NUMBER" class="input-no-border" style="color: #A3A3A3;" placeholder="0123344567" v-model="item.PhoneNumber" @input="validatePhoneNumberArray(item)"/>
                                                 
                                                </div>
                                            </div>

                                            <span v-if="item.phoneError" class="text-danger">{{ item.phoneError }}</span>
                                        </div>
                                    </CCol>
                                    <CCol sm="12" md="6" lg="2">
                                        <label> Tahap  Level<img @click="OpenPopup()" class="ml-2" src="../assets/img/iconInfo.png" style="max-width:20px"/></label>
                                        <v-select v-model="item.TypeLevel" :options="level" label="Name" placeholder="--Sila Pilih Tahap--" required style="border-radius:50px"></v-select>
    
    
                                    </CCol>
                                    <CCol sm="12" md="12" lg="1">
                                        <br />
                                        <div class="mt-4">
                                            <img src="../assets/img/trash2.png" style="max-width:20px" v-on:click="removemember(index)" />
                                            <!-- <label class="ml-2" v-on:click="removemember(index)"> Remove </label> -->
                                        </div>
                                        <br />
                                    </CCol>
                                </CRow>
                            
                            </CCard>
                            <div>
                                <!-- <CButton type="button" class="button-blue text-white mt-4" @click="validateAndRegister"
  :disabled="isFormInvalid"><label class="ml-5 mr-5 mt-2">Confirm and Pay</label></CButton> -->
  <CButton 
  type="button" 
  :class="{'button-blue text-white': !isFormInvalid, 'bg-grey': isFormInvalid}" 
  @click="validateAndRegister"
  :disabled="isFormInvalid">
  <label class="ml-5 mr-5 mt-2">Confirm and Pay</label>
</CButton>
                            </div>
    
                        </CCard>
                    </div>
    
    
    
                    <div v-if="isPopupLevel" class="popup-all backdrop-all">
                        <div class="popup-all1">
                            <div class="text-right">
                                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                            </div>
    
                            <!-- Popup content -->
                            <div class="custom-scroll">
                                <div class="text-left">
    
                                    <p v-html="tour.Content"></p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div v-if="isPopupError" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/register-closed.jpg" />
                    <h3 class="custom-18px-400 font-color-171717 text-center mt-3">
                        We’re sorry, but registration for this tournament has now closed. Thank you for your interest, and stay tuned for upcoming events!
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>
    
                </div>
            </CCol>
    
        </CCol>
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Popovers from '@/views/base/Popovers'


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
        Popovers
    },
    created() {
        this.GetListTourBYId();
        AOS.init();
        this.AddMember();

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,
            TeamName: "",
            ManagerName: "",
            Category: "",
            Amount: "",
            Email: "",
            PhoneNumber: "",
            Name: "",
            IdentityNumber: "",
            members: [],
            tour: {},
            chargePerMember: 0,
            level: [],
            SelectedLevel: [],
            isPopupLevel: false,

            teamNameError: '',
            managerNameError: '',
            emailError: '',
            phoneError: '',
            identityNumberError: '',

            isPopupError: false



        };
    },
    async mounted() {

        this.GetListTourBYId();
        this.GetListLevel();
    },
    computed: {

        totalAmount() {
            return (this.tour.ChargePerMember * this.members.length) + this.tour.Amount;
        },
        popoverOptions() {
            return {
                'v-c-popover': {
                    header: 'Test Header',
                    content: this.tour.Content || '', // Fallback to empty string if undefined
                    html: true,
                    trigger: 'click'
                }
            };
        }

    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        async GetListTourBYId() {
            this.$API
                .get(this.$GetListTourById + "?id=" + this.$route.query.id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.tour = response.data;
                        this.getThumbnail(this.tour.FilePath);
                        this.getBanner(this.tour.FilePathBanner);
                        console.log("Tour Content Loaded:", this.tour.Content); // Debugging
                        if (!this.tour.IsAcceptRegistration) {
                            this.isPopupError = true; // Show the popup if registration is closed
                        }
                    }
                });
        },
        getThumbnail(FilePath) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + FilePath
            );
        },
        getBanner(FilePathBanner) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + FilePathBanner
            );
        },
        GetListLevel() {
            this.$API
                .get(this.$GetListLevel)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.level = response.data;
                    }
                });
        },

        RegisterTeam() {
            const formData = new FormData();

            var team = [];
            for (let i in this.members) {
                let item = this.members[i];

                team.push({
                    Name: item.Name,
                    PhoneNumber: item.PhoneNumber,
                    identityNumber: item.IdentityNumber,
                    TypeLevel: item.TypeLevel ? item.TypeLevel.Id : null
                });
            }
            let teamJson = JSON.stringify(team);

            formData.append("TeamName", this.TeamName);
            formData.append("ManagerName", this.ManagerName);
            formData.append("IdentityNumber", this.IdentityNumber);
            formData.append("TypeLevel", this.SelectedLevel.Id);
            formData.append("Category", this.tour.Category);
            formData.append("Amount", this.totalAmount);
            formData.append("Email", this.Email);
            formData.append("PhoneNumber", this.PhoneNumber);
            formData.append("teamJson", teamJson);
            formData.append("Title", this.tour.Title);
            formData.append("TournamentId", this.$route.query.id);

            return this.$API
                .post(this.$InsertRegistrationTeam, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.billId = response.data;
                        // this.$dialog
                        // .alert("Registered.")
                        window.open(
                            "https://www.billplz.com/bills/" + this.billId
                        );

                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.Busy = false;
                        this.Error = true;
                        console.log(error.response.status);
                    }
                });
        },

        AddMember() {
            var lastId = 1;
            var length = this.members.length;
            if (length > 0) lastId = this.members[length - 1].Id;

            this.members.push({
                Id: lastId + 1,
                Name: "",
            });
        },

        removemember: function(index) {
            this.members.splice(index, 1);
        },

        downloadRule(terms) {
            console.log("tt" + terms);
            const pdfURL = 'https://sportcenter.s3.ap-southeast-1.amazonaws.com/' + terms;

            // Create an anchor element
            const link = document.createElement('a');
            link.href = pdfURL;
            link.target = '_blank';

            // Set the download attribute to force download
            link.setAttribute('download', terms);

            // Append the anchor element to the body
            document.body.appendChild(link);

            // Trigger a click event on the anchor element
            link.click();

            // Clean up by removing the anchor element
            document.body.removeChild(link);
        },
        closePopup() {
            this.isPopupLevel = false;
        },
        OpenPopup() {
            this.isPopupLevel = true;
        },
        validateEmail() {
      // Regular expression for basic email format validation
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(this.Email)) {
        this.emailError = 'Please enter a valid email address.';
      } else {
        this.emailError = ''; // Clear the error if valid
      }
      this.checkFormValidity();
    },
    validatePhoneNumber() {
      // Regular expression for phone number validation (10-12 digits, starts with 0)
      const phonePattern = /^0\d{9,11}$/;
      if (!phonePattern.test(this.PhoneNumber)) {
        this.phoneError = 'Please enter a valid phone number (10-12 digits).';
      } else {
        this.phoneError = ''; // Clear the error if valid
      }
      this.checkFormValidity();
    },
    // checkFormValidity() {
    //   // Check if both phone and email are valid
    //   this.isFormInvalid = this.emailError || this.phoneError || !this.Email || !this.PhoneNumber;
    // },

    checkFormValidity() {
        if (this.members && this.members.length > 0) {
  // Loop through all members and check for errors
  const hasErrorsInMembers = this.members.some((member) => {
    return member.phoneError || member.identityNumberError || !member.PhoneNumber || !member.IdentityNumber;
  });
  this.isFormInvalid = this.identityNumberError || this.phoneError || hasErrorsInMembers;
}

  // Check if both individual fields and member fields are valid
  this.isFormInvalid = this.emailError || this.phoneError || !this.Email || !this.PhoneNumber;
},

    validateAndRegister() {
      this.validateEmail();
      this.validatePhoneNumber();
      this.validateTeamName();
      this.validateManagerName();
      this.validateIdentityNumber();
      if (this.members && this.members.length > 0) {
    this.members.forEach((member) => {
      this.validateIdentityNumberArray(member);
      this.validatePhoneNumberArray(member);
    });
  }

      if (!this.isFormInvalid) {
        this.RegisterTeam(); // Proceed if form is valid
      }
    },
    validateTeamName() {
      if (!this.TeamName) {
        this.teamNameError = "Team's Name is required.";
      } else {
        this.teamNameError = '';
      }
      this.checkFormValidity();
    },
    validateManagerName() {
      if (!this.ManagerName) {
        this.managerNameError = "Manager's Name is required.";
      } else {
        this.managerNameError = '';
      }
      this.checkFormValidity();
    },
    validateIdentityNumber() {
      // Regular expression for number-only validation
      const numberPattern = /^\d+$/;
      if (!numberPattern.test(this.IdentityNumber)) {
        this.identityNumberError = 'Identity Number must contain only numbers.';
      } else {
        this.identityNumberError = ''; // Clear error if valid
      }
      this.checkFormValidity();
    },
    
    validatePhoneNumberArray(item) {
      const phonePattern = /^0\d{9,11}$/;
      if (!phonePattern.test(item.PhoneNumber)) {
        item.phoneError = 'Please enter a valid phone number (10-12 digits).';
      } else {
        item.phoneError = '';
      }
      this.checkFormValidity();
    },
    
    validateIdentityNumberArray(item) {
      const numberPattern = /^\d+$/;
      if (!numberPattern.test(item.IdentityNumber)) {
        item.identityNumberError = 'Identity Number must contain only numbers.';
      } else {
        item.identityNumberError = '';
      }
      this.checkFormValidity();
    }



    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}

.popover-old {
    max-width: 300px;
}
</style>